export function getDomain(urlString: string | undefined | null): string {
    if (urlString) {
        const url = new URL(urlString);
        return url.origin;
    }
    return '';
}
